import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import React, { useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import 'react-toastify/dist/ReactToastify.css';
import 'swiper/css';
import 'swiper/css/navigation';
import "aos/dist/aos.css";
import Header from "./component/header";
import Footer from "./component/Footer";
import About from "./pages/About"
import Home from "./pages/home";
import Contact from "./pages/Contact";
import Shop from "./pages/Shop";
import Product_description from "./pages/productdecription";
import Terms from "./pages/TermsConditions";
import Privacy from "./pages/PrivacyPolicy";
import Refund from "./pages/ReturnPolicy";
import CheckOut from "./pages/CheckOut";
import Cart from "./pages/cartItemsData";
import ConfirmCheck from "./pages/ConfirmCheck";
import Thankyou from "./pages/ThankYouPage";
import Categrios from "./pages/Categrios";
import ScrollTop from "./component/ScrollTop";
import Profile from "./account_area/Profile";
import Order from "./account_area/Order";
import OrderDetail from "./account_area/OrderDetail";
import { ToastContainer } from "react-toastify";
import Forgot from "./pages/Forgot";
import VarifyOTP from "./pages/VarifyOTP";
import UpdatePassword from "./pages/UpdatePassword";
import Dashboard from "./account_area/Dashboard";
import ResetPassword from "./account_area/ResetPassword";
import { useSettings } from "./context/settingContext";
import NotFound from "./pages/NotFound";
import Wishlist from "./account_area/Wishlist";
import StripePaymentForm from "./component/StripePaymentForm";
import CancelOrder from "./pages/CancelOrder";
import PaypalSuccess from "./pages/PaypalSuccess";

const stripePromise = loadStripe('pk_test_51SGdCrBrOEagRPXt4EriJRjZVSFig2cdIgyLoi9dx3FvVLIiECidiLfgzQGcUYQkFmF2P7VODXxTbcLBtiCwdzCP00UMeCh6oP');
function App() {

  const { settings } = useSettings();

  useEffect(() => {
    const linkElement = document.querySelector('link[rel="icon"]');
    if (linkElement && settings?.favicon) {
      linkElement.setAttribute("href", settings.favicon);
    }
    if (settings?.title) {
      document.title = settings.title;
    }
  }, [settings]);

  return (
    <>
      <Header />
      <ScrollTop />
      <Routes>
        <Route path="*" element={<NotFound />} />
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/shop" element={<Shop />} />
        <Route path="/product/:id" element={<Product_description />} />
        <Route path="/checkout" element={<CheckOut />} />
        <Route path="/cart" element={<Cart />} />
        <Route path="/categrios/:id" element={<Categrios />} />
        <Route path="/thankyou" element={<Thankyou />} />
        <Route path="/confirm-check" element={<ConfirmCheck />} />
        <Route path="/terms-conditions" element={<Terms />} />
        <Route path="/privacy-policy" element={<Privacy />} />
        <Route path="/refund-policy" element={<Refund />} />
        <Route path="/forgot-password" element={<Forgot />} />
        <Route path="/otp-verification" element={<VarifyOTP />} />
        <Route path="/update-password" element={<UpdatePassword />} />
        <Route path="/payment" element={<Elements stripe={stripePromise}><StripePaymentForm /></Elements>} />
        <Route path="/cancel-order" element={<CancelOrder />} />
        <Route path="/paypal-success" element={<PaypalSuccess />} />
        <Route path="/dashboard/" element={<Dashboard />} />
        <Route path="/dashboard/profile" element={<Profile />} />
        <Route path="/dashboard/orders" element={<Order />} />
        <Route path="/dashboard/order/:id" element={<OrderDetail />} />
        <Route path="/dashboard/reset-password" element={<ResetPassword />} />
        <Route path="/dashboard/wishlist" element={<Wishlist />} />
      </Routes>
      <ToastContainer position="top-center" autoClose={3000} />
      <Footer />
    </>
  );
}

export default App;
